// Decide how to import a user-provided file based on its MIME type / extension.
// Returns 'screenshot' (image → OCR), 'pdf', 'csv', or 'unsupported'.
export function pickImportKind(file) {
  const type = (file.type || '').toLowerCase()
  const name = (file.name || '').toLowerCase()
  if (type.startsWith('image/')) return 'screenshot'
  if (type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf'
  if (type === 'text/csv' || name.endsWith('.csv')) return 'csv'
  return 'unsupported'
}
